import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import QRCode from "qrcode" ;

const PreviewFussl = ({ show, onHide, content, count = 1, scale }) => {


  // console.log('content ', content)

  const [qrCode, setQrCode] = useState("");

  // ============================================================
  // GENERATE QR CODE
  // ============================================================
  useEffect(() => {
    const generateQR = async () => {
      try {
        // ========================================================
        // QR CODE NOW LINKS TO LERROS CONTACT PAGE
        // Scanning this QR code will open the Lerros HQ contact page
        // ========================================================
        const qrData = "https://company.lerros.com/de/kontakt/zentrale";

        const qr = await QRCode.toDataURL(qrData, {
          width: 150,
          margin: 0,
          errorCorrectionLevel: "M",
        });

        setQrCode(qr);
      } catch (error) {
        console.error("QR Code generation error:", error);
        setQrCode("");
      }
    };

    generateQR();
  }, []);






  const createValidSizeListString = (data) => {
    if (!data?.TotalQtys || !data?.header)
      return { default_size_list: "", new_size_list: "" };

    const sizArr = data?.TotalQtys || [];
    const new_size_list = [];
    const default_size_list = [];

    for (let i = 0; i < 12; i++) {
      if (sizArr[i] !== 0) {
        new_size_list.push(sizArr[i]);
        default_size_list.push(data.header[i]);
      }
      else {
        new_size_list.push("");
        default_size_list.push("");
      }
    }

    // const valid_sizelist = default_size_list.join(" + ");
    // const valid_sizevalues = new_size_list.join(" + ") + " = " + sizArr[12];
    // return { valid_sizelist, valid_sizevalues };
    return { default_size_list, new_size_list };
  };

  // Generate values
  const { default_size_list, new_size_list } =
    createValidSizeListString(content);

  const tbl = `
    <div class="table-main">
    <div>
      <div class="table-row">
        <div class="common-first-cell article-cell">
          <div>ARTICLE NO.</div>
          <div class="common-first-cell first-inner-div">
            <h1>${content?.STY || "STY"}</h1>
          </div>
          <div class="nve-bacode-class">
            <hr class="hr-style-1" />
            NVE BARCODE
          </div>
        </div>
        <div class="common-first-cell color-cell-1">
          <div>COLOR NO</div>
          <div class="common-first-cell first-inner-div">
            <div><h2>${content?.CLRS[0] || "000"}</h2></div>
            <div><h2>${content?.CLRS[1] || ""}</h2></div>
            <div><h2>${content?.CLRS[3] ? "***" : content?.CLRS[2] || ""}</h2></div>
          </div>
        </div>
        <div class="common-first-cell lot-cell-1">
          <div class= "sub-first-cell" >LOT ASSORTMENT</div>
          <div class="common-first-cell first-inner-div-lot">
            <div><h4>${content?.LOTS[0] || "000"}</h4></div>
            <div><h4>${content?.LOTS[1] || ""}</h4></div>
            <div><h4>${content?.LOTS[3] ? "***" : content?.LOTS[2] || ""}</h4></div>
          </div>
        </div>
        <div class="common-first-cell lot-count-cell">
          <div>NO. OF LOT</div>
          <div class="common-first-cell first-inner-div"><h2>${content?.NoOfLots || 1}</h2></div>
        </div>
        <div class="common-first-cell po-cell">
          <div>PO NUMBER</div>
          <div class="common-first-cell first-inner-div">
            <h1>${content?.PO || ""}</h1>
          </div>
        </div>
      </div>
      
       
  
        <div class="table-row second-container">
        <div class="row-middle-main-div">
        <div class="row-middle">
                <div class="common-cell barcode-cell">
                  <svg></svg>           
                <div class="table-row" style="padding: 0;">
                <div class="common-cell carton-and-qlt-pieces-cell">
                <div class="carton-and-qlt-pieces-cell-child">CARTON SIZES</div>
              </div>
              </div>
              </div>
                  <div class="comman-first-cell-container-main">
                    <div class="comman-first-cell-container">
                      <div class="comman-first-cell-container1">
                        <div class="common-first-cell color-cell">
                            <div>CARTON NO.</div>
                              <div class="common-first-cell first-inner-div">
                                <div><h2>${content?.SNO || ""}</h2></div>
                              </div>
                          </div>
                          <div class="common-first-cell lot-cell">
                            <div class= "sub-first-cell" >GROSS WT(KG)</div>
                              <div class="common-first-cell first-inner-div">
                                <div><h2>${content?.GrossWt || ""}</h2></div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="comman-first-cell-container">
                          <div class="common-first-cell color-cell">
                            <div>QTY PIECES</div>
                              <div class="common-first-cell first-inner-div">
                                <div><h2>${content?.QtyPcs || ""}</h2></div>
                              </div>
                          </div>
                          <div class="common-first-cell lot-cell">
                            <div class= "sub-first-cell" >NET WT(KG)</div>
                              <div class="common-first-cell first-inner-div">
                                <div><h2>${content?.NetWt || ""}</h2></div>
                              </div>
                            </div>
                      </div>
                      <div class="lot-conton-no"> ${`${content?.length || ""}*${content?.width || ""}*${content?.height || ""}`}
                      </div>
                    </div>

                    </div>
                    <div class="table-row" style="padding:0px">
                    <div class="common-cell carton-size-cell" style="margin: 0">
                      <hr class="hr-style-2" />
                      <div style="display: flex; height: 50%; width: 100%">
                        <div
                          style="
                            height: 44px;
                            width: 74px;
                            display: flex;
                            justify-content: center;
                            align-items: center;"
                        >
                          <h3
                            class="text_fixed"
                          >SIZES</h3>
                        </div>
                        <hr class="hr-style-3" />
                        <div
                          style="height: 44px; width: 74px; padding: 5px"
                        > <h2>${content?.header[0] || ""
    }</h2> </div>
                        <hr class="hr-style-3" />
                        <div
                          style="height: 44px; width: 74px; padding: 5px"
                        > <h2>${content?.header[1] || ""
    }</h2></div>
                        <hr class="hr-style-3" />
                        <div
                          style="height: 44px; width: 74px; padding: 5px"
                        ><h2>
                          ${content?.header[2] || ""
    }</h2>
                        </div>
                        <hr class="hr-style-3" />
                        <div
                          style="height: 44px; width: 74px; padding: 5px"
                        ><h2>
                          ${content?.header[3] || ""
    }
                          </h2>
                        </div>
                        <hr class="hr-style-3" />
                        <div
                          style="height: 44px; width: 74px; padding: 5px"
                        ><h2>
                          ${content?.header[4] || ""
    }</h2>    
                        </div>
                        <hr class="hr-style-3" />
                        <div
                          style="height: 44px; width: 74px; padding: 5px"
                        ><h2>
                          ${content?.header[5] || ""
    }</h2>
                        </div>
                        <hr class="hr-style-3" />
                        <div
                          style="height: 44px; width: 74px; padding: 5px"
                        ><h2>
                          ${content?.header[6] || ""
    }</h2>
                        </div>
                        <hr class="hr-style-3" />
                        <div
                          style="height: 44px; width: 74px; padding: 5px"
                        ><h2>
                          ${content?.header[7] || ""
    }</h2>
                        </div>
                        <hr class="hr-style-3" />
                        <div
                          style="height: 44px; width: 42px; padding: 5px"
                        ><h2>
                        ${content?.header[8] || ""
    }</h2>
                          </div>
                        <hr class="hr-style-3" />
                        <div
                          style="height: 44px; width: 74px; padding: 5px"
                        ><h2>
                        ${content?.header[9] || ""
    }</h2>
                        </div>
                        <hr class="hr-style-3" />
                        <div
                          style="height: 44px; width: 74px; padding: 5px"
                        ><h2>
                        ${content?.header[10] || ""
    }</h2>
                        </div>
                        <hr class="hr-style-3" />
                        <div
                          style="height: 44px; width: 74px; padding: 5px"
                        ><h2>${content?.header[11] || ""
    }</h2></div>
  
                        <hr class="hr-style-3" />
                        <div
                          style="
                            height: 44px;
                            width: 74px;
                            margin: 15px 0 0 20px;
                            padding: 0;
                          "
                        >
                          <h3>TOTAL</h3>
                        </div>
                      </div>
                      <hr class="hr-style-4" />
                      <div style="display: flex; height: 100%; width: 100%; padding: 0; margin:0;">
                        <div
                          style="
                          height: 44px;
                          width: 74px;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          padding: 0px 0px 13px 9p
                          "
                        >
                          <h3>PIECES</h3>
                        </div>
  
                        <div class="peiceDiv"> <h2>${content?.TotalQtys[0] === 0 || content?.TotalQtys[0] === "0"
      ? ""
      : content?.TotalQtys[0] || ""
    }</h2></div>
  
                        <div class="peiceDiv"><h2>${content?.TotalQtys[1] === 0 || content?.TotalQtys[1] === "0"
      ? ""
      : content?.TotalQtys[1] || ""
    }</h2></div>
  
                        <div class="peiceDiv1">
                          <h2>${content?.TotalQtys[2] === 0 || content?.TotalQtys[2] === "0"
      ? ""
      : content?.TotalQtys[2] || ""
    }</h2>
                        </div>
  
                        <div class="peiceDiv"><h2>${content?.TotalQtys[3] === 0 || content?.TotalQtys[3] === "0"
      ? ""
      : content?.TotalQtys[3] || ""
    }</h2></div>
  
                        <div class="peiceDiv" ><h2>${content?.TotalQtys[4] === 0 || content?.TotalQtys[4] === "0"
      ? ""
      : content?.TotalQtys[4] || ""
    }</h2></div>
  
                        <div class="peiceDiv1"
                        ><h2>${content?.TotalQtys[5] === 0 || content?.TotalQtys[5] === "0"
      ? ""
      : content?.TotalQtys[5] || ""
    }</h2></div>
  
                        <div class="peiceDiv1" ><h2>${content?.TotalQtys[6] === 0 || content?.TotalQtys[6] === "0"
      ? ""
      : content?.TotalQtys[6] || ""
    }</h2></div>
  
                        <div class="peiceDiv1"><h2>${content?.TotalQtys[7] === 0 || content?.TotalQtys[7] === "0"
      ? ""
      : content?.TotalQtys[7] || ""
    }</h2></div>
  
                        <div class="peiceDiv"><h2>${content?.TotalQtys[8] === 0 || content?.TotalQtys[8] === "0"
      ? ""
      : content?.TotalQtys[8] || ""
    }</h2></div>
                  <div class="peiceDiv1"><h2>${content?.TotalQtys[9] === 0 || content?.TotalQtys[9] === "0"
      ? ""
      : content?.TotalQtys[9] || ""
    }</h2></div>
                  <div class="peiceDiv1"
                        ><h2>${content?.TotalQtys[10] === 0 || content?.TotalQtys[10] === "0"
      ? ""
      : content?.TotalQtys[10] || ""
    }</h2></div>
                  <div class="peiceDiv2" ><h2>${content?.TotalQtys[11] === 0 || content?.TotalQtys[11] === "0"
      ? ""
      : content?.TotalQtys[11] || ""
    }</h2></div>
                  <div class="peiceDiv3">
                    <h2>${content?.TotalQtys[12] === 0 || content?.TotalQtys[12] === "0"
      ? ""
      : content?.TotalQtys[12] || ""
    }</h2>
              </div>

            </div>
            
          </div>

  
        </div>
        </div>
        <div class="common-cell lot-barcode-cell">
            <div> FUSSL ORDER NO.</div>
            <div class="lot-and-ean">
              ${content?.orderNo || ''}
            </div>
            <div class="PreviewFussl-line-5" ></div>
            <div> LOT BARCODE </div>
              <div class="lot-and-ean">
                
              </div>
            <div class="carton-size-cell-new">      
                ${`<h3>SPECIAL MARKING/CUSTOMER PO NO  ${content?.FCUS}</h3>`}
            </div>
      </div>
       <div class="container_1_qr">
              <div class="qr-main">
                  <div class="carton-id">${content?.carton_ID}</div>
                  <img
                    src="${qrCode}"
                    class="qr-code"
                    alt="QR Code"
                  />
               </div>
          </div>
      </div>
  </div>
 
  
  `



  // const tbl = `<div>checking 5</div>`

  const htmlContent = `<html lang="en">
      <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Complex Table with Flexbox</title>
      <style>
  

  
        .table-row {
          display: flex;
          align-items: start;
        }
        .row-middle{
          // border: 2px solid green;
          display: flex;
          padding: 0px !important;
          width: fit-content;
      }
      
        .row-middle-main-div{
          // border:2px solid blue !important;
          padding:0px !important;
          height: 317px;
        }
        .common-cell {
          display: flex;
          flex-direction: column;
          text-align: center;
        }
        .comman-first-cell-container-main{
          padding: 0px !important;
        }
  
        .common-first-cell {
          display: flex;
          flex-direction: column;
          text-align: center;
  
          height: 130px;
        }
  
        .article-cell {
          padding: 0px;
          text-align: center;
          width: 575px;
          height: 116px;
          border: 1px solid #000;
          // border-bottom: none;
        }
        .color-cell {
          padding: 10px;
          width: 100px;
          height: 116px;
          border: 1px solid #000;
          border-left: none;
          border-right: none;
          border-top: none;
        }
        .color-cell-1{
          padding: 10px;
          width: 100px;
          height: 116px;
          border: 1px solid #000;
          border-left: none;
          border-right: none;
        }
        .lot-cell {
          padding: 10px;
          width: 155px;
          height: 116px;
          border: 1px solid #000;
          border-right: none;
          border-top: none;
        }
        .lot-cell-1{
          padding: 10px;
          width: 155px;
          height: 116px;
          border: 1px solid #000;
          border-right: none;
        }
        .lot-count-cell {
          padding: 10px;
          width: 136px;
          height: 116px;
          border: 1px solid #000;
          border-right: none;
        }
        .po-cell {
          width: 244px;
          height: 116px;
          border: 1px solid #000;
        }
  
        .first-inner-div {
          flex: 1;
          justify-content: center;
          align-items: center;
          height: 100%;
          padding:0px !important;
        }
        .first-inner-div-lot, h4{
          font-size: 20px !important;
          padding: 0px;
          margin: 0px;
          font-weight:700;
        }
  
        .sub-first-cell{
          // border: 2px solid red;
        }


        .first-inner-div-clr {
          flex: 1;
          justify-content: center;
          align-items: center;
          height: 100%;
        }
        .comman-first-cell-container{
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0px !important;
        }
        .comman-first-cell-container1{
          width:255px !important;
          // border:2px solid blue;
          display:flex;
        }
  
        .barcode-cell {
          // padding: 10px 0 0 0;
          width: 575px;
          height: 290px;
          border: 1px solid #000;
          border-top: none;
          padding: 0px !important
        }
  
        .table-row{
          padding:0px
        }
        .second-container{
          // border: .5px solid red;
          display: flex;
          width: fit-content;
        }
        .carton-and-qlt-pieces-cell {
          padding: 10px;
          margin-top: 80px;
          width: 600px;
          border: 1px solid black;
          border-right: none;
          border-left: none;
          border-bottom: none;
        }

        .carton-and-qlt-pieces-cell-child{
          width: fit-content;
          font-size: 22px;
          font-weight: 600;
        }
  
        .special-marking-cell-new {
          padding: 5px;
          width: 233px;
          min-height: 260px;
          border: 1px solid #000;
        }
  
        .gross-and-net-wt-cell {
          padding: 10px;
          margin-top: 5px;
          width: 150px;
          height: 95px;
          border: 1px solid #000;
          border-bottom: none;
        }
  
        .lot-barcode-cell {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          position: relative;
          // padding: 10px;
          width: 380px;
          height: 397px !important;
          border: 1px solid #000;
          padding: 0px !important;
          border-top: none;
        }
        .nve-bacode-class{
          border  2px solid red
        }
        .carton-size-cell-new{
          margin-bottom: -2.6% !important;
        }
  
        .carton-size-cell {
          width: 830px;
          height: 107px;
          border: 1px solid #000;
          border-top: none;
          border-right: none;
        }
  
        .volume-measure-cell {
          padding: 0 10px 0 10px;
          width: 212px;
          height: 85px;
          border: 1px solid #000;
          border-right: none;
          border-left: none;
          border-bottom: 1px solid #000;
        }
  
        .special-marking-cell {
          padding: 10px;
          width: 361px;
          height: 65px;
          border-top: none;
          border: 1px solid #000;
          border-left: none;
        }
  
        .carton-size-cell-new {
          padding: 6px 0 0 0;
          // margin: 0 -10px 0 -10px;
          height: 116px;
          border: none;
          border-top: 1px solid #000;
          margin-top: auto;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .carton-size-cell-new h3{
          font-size: 18px;
          font-weight:bolder;
        }
  
        h1,
        h2,
        h3 {
          margin: 0;
          font-size: 15px;
          font-weight: 700;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        h1 {
          font-size: 50px;
          font-weight: 900;
        }
        h2 {
          font-size: 25px;
          font-weight: 700;
        }
  
        .hr-style-1 {
          border: 1px solid white;
          // margin: -6px -20px 10px -18px;
        }
        .hr-style-2 {
          // border: 1px solid #000;
          margin: 0px;
          width: 1170px;
          height: 1px;
          display:none
        }
  
        .hr-style-3 {
          height: 108px;
          border: 1px solid #000;
          margin: -1px 0 0px 0;
        }
  
        .hr-style-4 {
          margin: 0px 0px 0px 0px;
          width: 830px;
          margin: 0;
          padding:4px !important;
        }
        .PreviewFussl-line-5 {
          margin: 0px 0px 0px 0px;
          width: 378px;
          margin: 0;
          padding:0px !important;
          margin-top: 29px;
          border: .1px solid black !important;
          border-bottom: none !important;
        }

        .lot-conton-no{
          border: 1px solid black;
          height: 58px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-left: none;
          border-right: none;
          border-top: none;
          font-size:25px;
          font-weight:700
        }
        .peiceDiv{
          height: 44px;
          width: 76px;
          display: flex;
          // border: 2px solid red;
          justify-content: center;
          align-items: center;
          // padding: 0px 0px 13px 9px
        }
        .peiceDiv1{
          height: 44px;
          width: 75px;
          display: flex;
          // border: 2px solid green;
          justify-content: center;
          align-items: center;
          // padding: 0px 0px 13px 9px
        }
        .peiceDiv2{
          height: 44px;
          width: 79px;
          display: flex;
          // border: 2px solid green;
          justify-content: center;
          align-items: center;
        }
        .peiceDiv3{
          height: 44px;
          width: 129px;
          display: flex;
          // border: 2px solid green;
          justify-content: center;
          align-items: center;
        }
        .tables-container {
          /* display: flex !important; */
          // border: 1px solid red;
          /* flex-direction: column-reverse; */
          width: 100%;
          height: 100vh;
          margin-bottom: 450px;
          overflow: visible;
          /* transform-origin: 700px top;
          transform: rotate(-90deg) translateX(-100%) scaleY(0.63) scaleX(0.8); */
        }
        
  
        .common-cell lot-barcode-cell {
          display: flex;
          flex-direction: row;
          justify-content: center;
        }
        .lot-and-ean {
          // border : 2px solid red;
          font-size:30px;
          font-weight: 700;
          margin:8px;
          padding: 0px !important;
        }
        .hr-style-16-container {
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 31px 0; /* Add some vertical spacing */
          width: 1150px;
        }
  
        hr.style-16 {
          flex-grow: 1;
          border: none; /* Remove default border */
          border-top: 2px dashed black;
        }
  
        .hr-style-16-container span {
          display: inline-block;
          padding: 0 10px;
          background: #f0f0f0; /* Background color to overlap the line */
          font-size: 18px;
        }
        .container_1_qr {
          align-self: stretch;       /* row (lot-barcode-cell) ki height tak stretch hoga */
          display: flex;
        }

      .qr-main {
        width: fit-content;
        min-width: 100px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end; 
        align-items: flex-start;   
        height: auto;             
        padding-left: 3em;
      }

    .qr-code {
      width: 100px;
      height: 100px;
      display: block;
      object-fit: contain;
      margin-bottom: 0;         
    }
        .table-main{
        //  border:2px solid red;    
         display: flex;
         flex-direction: column;    
         }

        .carton-id {
          padding: 0 4px 10px 0;
          font-weight: 500;
          white-space: nowrap;       /* text wrap nahi hoga */
          width: fit-content;
          text-align: left;
        }

      </style>
  
    </head>
        <body>
          <div class="tables-container">
                ${tbl}
                  <div class="hr-style-16-container">
                    <hr class="hr-style-16">
                    <span>&#x2702;</span>
                    <hr class="style-16">
                  </div>
                ${tbl}
          </div>
        </body>
    </html>`
  return (
    // <Modal.Body
    //       style={{
    //         height: 'auto',
    //         overflow: 'auto',
    //         padding: '4px',
    //         backgroundColor: '#f8f9fa', 
    //         // border: '2px solid blue',
    //         boxShadow: '0 0 10px rgba(0,0,0,0.1)',
    //         display: 'flex',
    //         justifyContent: 'center',
    //         alignItems: 'center',
    //       }}
    //     >
    <div
      style={{
        width: 'auto',
        height: 'auto',
        overflow: 'visible',
        zoom: scale,
        padding: "100px",
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      dangerouslySetInnerHTML={{
        __html: htmlContent
      }}
    ></div>
    // </Modal.Body>

  );
};

export default PreviewFussl;
